<template>
  <div class="document">
    <div class="header">
      <EsHeader>
        <template #header>
          <div class="header-title">
            Add Data Mart
          </div>
        </template>
      </EsHeader>
      <div class="icons" v-if="!loading && !loadingError">
      </div>
    </div>
    <div class="content">
      <es-loader v-if="loading" />
      <es-exception v-else-if="loadingError"
        exceptionMessage="There was an issue. Please try again or contact your administrator." />
      <div v-else>
        <table role="presentation">
          <tbody>
            <tr>
              <td class="has-text-grey" style="width: 625px">
                Mart Type
              </td>
              <td class="text">
                <div class="control">
                  <es-select valueTpl="${name}"
                    :setValues="sortedDatamartTypes" keyValue="id"
                    v-on:update:values="selectedMartType = $event; validateSelectField('martType')"
                    ref="resetMartType" />
                </div>
                <span v-if="hasErrorMartType" class="help is-danger">
                  {{ msgMartType }}
                </span>
              </td>
            </tr>
            <tr>
              <td class="has-text-grey" style="vertical-align: middle; width: 50%">
                Destination Display Name
              </td>
              <td class="text">
                <div class="control">
                  <input class="input is-pulled-right"
                    :class="{ 'is-danger': hasErrorDisplayName }"
                    title="Destination Display Name"
                    type="text"
                    v-model="displayName"
                    @keyup.prevent="validateInputField('displayName')"
                    aria-label="Destination Display Name" />
                </div>
                <span v-if="hasErrorDisplayName" class="help is-danger">
                  {{ msgDisplayName }}
                </span>
              </td>
            </tr>
            <tr>
              <td class="has-text-grey" style="vertical-align: middle; width: 50%">
                Destination Table Name
              </td>
              <td class="text">
                <div class="control">
                  <input class="input is-pulled-right"
                    :class="{ 'is-danger': hasErrorTableName }" type="text"
                    v-model="tableName"
                    @keyup.prevent="validateInputField('tableName')"
                    aria-label="Destination Table Name" />
                </div>
                <span v-if="hasErrorTableName" class="help is-danger">
                  {{ msgTableName }}
                </span>
              </td>
            </tr>
              <tr>
                <td class="has-text-grey" style="vertical-align: middle; width: 50%">
                  Destination Driver Name
                </td>
                <td class="text">
                  <div class="control">
                    <input class="input is-pulled-right"
                      :class="{'is-danger': hasErrorDriverName }"
                      type="text"
                      v-model="driverName"
                      @keyup.prevent="validateInputField('driverName')"
                      aria-label="Destination Driver Name" />
                    <span v-if="hasErrorDriverName" class="help is-danger">
                      {{ msgDriverName }}
                    </span>
                  </div>
                </td>
              </tr>
            <tr>
              <td class="has-text-grey" style="vertical-align: middle; width: 50%">
                Destination Connection URL
              </td>
              <td class="text">
                <div class="control">
                  <input class="input is-pulled-right"
                    :class="{ 'is-danger': hasErrorConnectionURL }"
                    type="text"
                    v-model="connectionURL"
                    @keyup.prevent="validateInputField('connectionURL')"
                    aria-label="Destination Connection URL" />
                </div>
                <span v-if="hasErrorConnectionURL" class="help is-danger">
                  {{ msgConnectionURL }}
                </span>
              </td>
            </tr>
            <tr>
              <td class="has-text-grey" style="vertical-align: middle; width: 50%">
                Destination Connection Username
              </td>
              <td class="text">
                <div class="control">
                  <input class="input is-pulled-right"
                    :class="{ 'is-danger': hasErrorUserName }"
                    type="text"
                    v-model="userName"
                    @keyup.prevent="validateInputField('userName')"
                    aria-label="Destination Connection Username" />
                </div>
                <span v-if="hasErrorUserName" class="help is-danger">
                  {{ msgUserName }}
                </span>
              </td>
            </tr>
            <tr>
              <td class="has-text-grey" style="vertical-align: middle; width: 50%">
                Destination Connection Password
              </td>
              <td class="text">
                <div class="control">
                  <input class="input is-pulled-right"
                    :class="{ 'is-danger': hasErrorPassword }"
                    type="text"
                    v-model="password"
                    @keyup.prevent="validateInputField('password')"
                    aria-label="Destination Connection Password" />
                </div>
                <span v-if="hasErrorPassword" class="help is-danger">
                  {{ msgPassword }}
                </span>
              </td>
            </tr>
            <tr>
              <td class="has-text-grey" style="width: 625px">
                Destination Status
              </td>
              <td class="text">
                <div class="control">
                  <button class="button button--form" v-for="(option, index) in statusOptions" :key="index"
                    @click="status = option.code"
                    :class="{ 'is-active': status === option.code }"
                    style="min-width: 100px">
                    {{ option.description }}
                  </button>
                </div>
              </td>
            </tr>
            <tr>
              <td class="has-text-grey" style="vertical-align: middle; width: 50%">
                Last Synchronization Date
              </td>
              <td>N/A</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-if="!loading && !loadingError" class="is-flex flex-justify--end flex-align--center"
      style="margin-right: 5.15rem; padding-bottom: 2rem">
      <button class="button button-link has-underline"
         @click.prevent="cancelPanel()"
         style="margin-right: 1rem">
        Cancel
      </button>
      <button class="button is-primary"
        @click.prevent="addDatamart()">
        Add Data Mart
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapActions, mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDoubleLeft,
  faEdit,
  faTrashAlt,
} from '@fortawesome/pro-regular-svg-icons';
import EsException from '@/components/EsException.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';
import EsSelect from '@/components/EsSelect.vue';
import NotificationManager from '@/mixins/NotificationManager';

library.add(
  faAngleDoubleLeft,
  faEdit,
  faTrashAlt,
);

export default {
  mixins: [
    NotificationManager,
  ],
  components: {
    EsException,
    EsHeader,
    EsLoader,
    EsSelect,
  },
  created() {
    this.statusOptions = [
      {
        code: true,
        description: 'Active',
      },
      {
        code: false,
        description: 'Inactive(Suspended)',
      },
    ];
  },
  computed: {
    ...mapGetters('lookups', [
      'activeDatamartTypes',
    ]),
    sortedDatamartTypes() {
      return this.activeDatamartTypes.slice().sort(this.compare);
    },
  },
  data() {
    return this.initialData();
  },
  methods: {
    cancelPanel() {
      if (this.$refs.resetMartType)
        this.$refs.resetMartType.clear();
      this.driverName = null,
      this.connectionURL = null,
      this.displayName = null,
      this.tableName = null,
      this.status = true,
      this.userName = null,
      this.password = null,
      this.hasErrorDisplayName = false;
      this.msgDisplayName = '';
      this.hasErrorTableName = false;
      this.msgTableName = '';
      this.hasErrorDriverName = false;
      this.msgDriverName = '';
      this.hasErrorConnectionURL = false;
      this.msgConnectionURL = '';
      this.hasErrorUserName = false;
      this.msgUserName = '';
      this.hasErrorPassword = false;
      this.msgPassword = '';
      this.hasErrorMartType = false;
      this.msgMartType = '';
      this.hideNotification();
      this.$emit('dataMartList');

    },
    initialData() {
      return {
        loading: false,
        loadingError: false,
        driverName: null,
        connectionURL: null,
        displayName: null,
        tableName: null,
        selectedMartType: {},
        statusOptions: [],
        showModule: false,
        status: true,
        userName: null,
        password: null,
        hasErrorDisplayName: false,
        hasErrorTableName: false,
        hasErrorDriverName: false,
        hasErrorConnectionURL: false,
        hasErrorUserName: false,
        hasErrorPassword: false,
        hasErrorMartType: false,
        msgMartType: '',
        msgDisplayName: '',
        msgTableName: '',
        msgDriverName: '',
        msgConnectionURL: '',
        msgUserName: '',
        msgPassword: '',
      };
    },
     compare(a, b) {
      if (a.name.toUpperCase() < b.name.toUpperCase()) {
        return -1;
      }
      if (a.name.toUpperCase() > b.name.toUpperCase()) {
        return 1;
      }
      return 0;
    },
    validateInputField(fieldName) {
      const alphanumericRegex = /^[a-zA-Z0-9]+$/;
      const validTableNameRegex = /^[a-zA-Z0-9-_]+$/;
      const maxDisplayNameLength = 100;
      const maxTableNameLength = 100;
      const maxDriverNameLength = 250;
      const maxConnectionURLLength = 250;
      const maxUsernameLength = 50;
      const maxPasswordLength = 50;

      switch (fieldName) {
        case 'displayName':
          this.hasErrorDisplayName = !this.displayName;
          this.msgDisplayName = this.hasErrorDisplayName ? 'Destination Display Name is required.' : '';

          if (this.displayName
              && this.displayName.length > maxDisplayNameLength) {
            this.hasErrorDisplayName = true;
            this.msgDisplayName = `Destination Display Name allows a maximum of ${maxDisplayNameLength} characters.`;
          }
          break;
        case 'tableName':
          this.hasErrorTableName = !this.tableName;
          this.msgTableName = this.hasErrorTableName ? 'Destination Table Name is required.' : '';

          if (this.tableName && !validTableNameRegex.test(this.tableName)) {
            this.hasErrorTableName = true;
            this.msgTableName = 'Destination Table Name is invalid.';
          }

          if (this.tableName && this.tableName.length > maxTableNameLength) {
            this.hasErrorTableName = true;
            this.msgTableName = `Destination Table Name allows a maximum of ${maxTableNameLength} characters.`;
          }
          break;
        case 'driverName':
          this.hasErrorDriverName = !this.driverName
          this.msgDriverName = this.hasErrorDriverName ? 'Destination Driver Name is required.' : '';

          if (this.driverName && this.driverName.length > maxDriverNameLength) {
            this.hasErrorDriverName = true;
            this.msgDriverName = `Destination Driver Name allows a maximum of ${maxDriverNameLength} characters.`;
          }
          break;
        case 'connectionURL':
          this.hasErrorConnectionURL = !this.connectionURL;
          this.msgConnectionURL = this.hasErrorConnectionURL ? 'Destination Connection URL is required.' : '';

          if (this.connectionURL && this.connectionURL.length > maxConnectionURLLength) {
            this.hasErrorConnectionURL = true;
            this.msgConnectionURL = `Destination Connection URL allows a maximum of ${maxConnectionURLLength} characters.`;
          }
          break;
        case 'userName':
          this.hasErrorUserName = !this.userName;
          this.msgUserName = this.hasErrorUserName ? 'Destination Connection Username is required.' : '';

          if (this.userName && this.userName.length > maxUsernameLength) {
            this.hasErrorUserName = true;
            this.msgUserName = `Destination Connection Username allows a maximum of ${maxUsernameLength} characters.`;
          }

          if (this.userName && !alphanumericRegex.test(this.userName)) {
            this.hasErrorUserName = true;
            this.msgUserName = 'Destination Connection Username is invalid.';
          }
          break;
        case 'password':
          this.hasErrorPassword = !this.password;
          this.msgPassword = this.hasErrorPassword ? 'Destination Connection Password is required.' : '';

          if (this.password && this.password.length > maxPasswordLength) {
            this.hasErrorPassword = true;
            this.msgPassword = `Destination Connection Password allows a maximum of ${maxPasswordLength} characters.`;
          }
          break;
        default:
          break;
      }
    },
    validateSelectField(fieldName) {
      if (fieldName === 'martType') {
        this.hasErrorMartType = Object.keys(this.selectedMartType).length === 0;
        this.msgMartType = this.hasErrorMartType ? 'Mart Type is required.' : '';
      }
    },
    hasFieldErrors() {
      this.validateSelectField('martType');
      this.validateInputField('displayName');
      this.validateInputField('tableName');
      this.validateInputField('driverName');
      this.validateInputField('connectionURL');
      this.validateInputField('userName');
      this.validateInputField('password');
      const err =
        this.hasErrorDisplayName ||
        this.hasErrorTableName ||
        this.hasErrorDriverName ||
        this.hasErrorConnectionURL ||
        this.hasErrorUserName ||
        this.hasErrorPassword;

      if (err) {
        this.showNotification('danger', ['There were some errors.Please fix the errors highlighted in the fields below.']);
      } else {
        this.hideNotification();
      }

      return err;
    },
    async addDatamart() {
      if (this.hasFieldErrors()) return;
      try {
        const config = {
          driverName: this.driverName,
          url: this.connectionURL,
          username: this.userName,
          password: this.password,
        };
        const data = {
          // Construct the data object with the input values
          active: this.status,
          typeId: this.selectedMartType && this.selectedMartType.length > 0
            ? this.selectedMartType[0].id : null,
          label: this.displayName,
          tableName: this.tableName,
          config: JSON.stringify(config), // Serialize the config object as a JSON string
        };
        await axios.post(`datamart/destination`, data);
        this.showNotification('success', ['The Data Source has been added successfully.']);
        this.$emit('dataMartList');
      } catch (error) {
        if (error.response.status === 400) {
            this.apiMsg = `Error Adding datamart: ${error.response.data.message}`;
        } else {
          this.apiMsg = 'There was an issue. Please try again or contact your administrator.';
        }
        this.showNotification('danger', [this.apiMsg]);
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  table td
    font-size: 12px
    vertical-align: middle
  a.disabled
    color: #999
    cursor:  default
    text-decoration:  none
    pointer-events: none
    &:hover
      text-decoration:  none
  .category
    padding-top: 1.5rem
    border: 0
  .content
    padding: 0 3rem 0.5rem
    overflow-x: auto
  .header
    display: flex
    align-items: center
  .icons
    width: 100px
    display: flex
    justify-content: space-around
    padding-right: 1rem
  .modal-body
    margin-bottom: 1rem
    display: flex
    text-align: left
    justify-content: flex-start
  .modal-card-head
    padding: 8px 16px
  .modal-card-title
    display: flex
    font-size: 15.2px
  .no-border
    border: 0
  .rule
    font-size: 12px
    color: #666
  .text
    text-align: center
    font-size: 14px
</style>
